import { render, staticRenderFns } from "./InputTextArea.vue?vue&type=template&id=ca725e76&scoped=true"
import script from "./InputTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputTextArea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputTextArea.vue?vue&type=style&index=0&id=ca725e76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca725e76",
  null
  
)

export default component.exports